const CHARACTER_FILENAMES = {
  feng: 'Feng',
  ling: 'Ling',
  meng: 'Meng',
  ming: 'Ming',
  qi:   'Qi',
  yong: 'Yong',
};

// CHARACTER_FILENAMES is retained purely as the canonical lowercase-slug set
// (its capitalised values are no longer used now that figurines resolve through
// buddyManifest.js — BP-BUDDY-ATLAS-VIEW-01). getBuddyPortraitPath uses it to
// validate the slug.

// Avatar head crops live at /public/assets/buddies/{slug}/avatar-1.webp — lowercase
// slug, tight head-and-shoulders crop. This is the correct image for any circular
// avatar slot (sidebar, overlays, headers). Figurine (full-body map walk) art is
// resolved separately via the buddy manifest. Unknown slugs fall back to Ling.
// (ADR / Buddy-Service.md decision D-9.)
export function getBuddyPortraitPath(slug) {
  const key = String(slug || '').toLowerCase();
  const validSlug = key in CHARACTER_FILENAMES ? key : 'ling';
  return `/assets/buddies/${validSlug}/avatar-1.webp`;
}
